export default {
  HC_ADJUST_EVENT_LOGS: {
    path: '/hc-adjust-event-logs',
    name: 'hc_adjust_event_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/AdjustEventLogs')
  },
  HC_CLAIMS: {
    path: '/hc-claims',
    name: 'hc_claims',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'hc',
      title: 'Claims',
      order: 2
    },
    component: () => import('@hc_views/Claims/ClaimsIndex')
  },
  HC_COHORT_ANALYSIS: {
    path: '/hc-cohort-analysis',
    name: 'hc_cohort_analysis',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/CohortAnalysis/CohortAnalysisIndex.vue')
  },
  HC_COHORT_ANALYSIS_EXPORT: {
    type: 'function',
    path: 'hc_cohort_analysis_export',
    name: 'hc_cohort_analysis_export',
    permission: 'hc_cohort_analysis_export',
    meta: {
      requiresAuth: true
    }
  },
  HC_EMAILS: {
    path: '/hc-emails',
    name: 'hc_emails',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'hc',
      title: 'E-Mails',
      order: 3
    },
    component: () => import('@hc_views/Emails/EmailsIndex')
  },
  HC_PERFORMANCE: {
    path: '/hc-performance',
    name: 'hc_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/Performance/PerformanceIndex')
  },
  HC_PERFORMANCE_EXPORT: {
    type: 'function',
    path: 'hc_performance_export',
    name: 'hc_performance_export',
    permission: 'hc_performance_export',
    meta: {
      requiresAuth: true
    }
  },
  HC_REWARDS: {
    path: '/hc-rewards',
    name: 'hc_rewards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/Rewards')
  },
  HC_TRANSACTIONS: {
    path: '/hc-transactions',
    name: 'hc_transactions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'hc',
      title: 'Transactions',
      order: 1
    },
    component: () => import('@hc_views/Transactions/TransactionsIndex')
  },
  HC_LEVELS: {
    path: '/hc-levels',
    name: 'hc_levels',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/Level')
  },
  HC_LEADERBOARDS: {
    path: '/hc-leaderboards',
    name: 'hc_leaderboards',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/Leaderboards/LeaderboardsIndex')
  },
  HC_AFFILIATE_PARTNERS: {
    path: '/hc-affiliate-partners',
    name: 'hc_affiliate_partners',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/AffiliatePartners/AffiliatePartnersIndex')
  },
  HC_USERS: {
    path: '/hc-users',
    name: 'hc_users',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/Users/UsersIndex')
  },
  HC_USERS_EXPORT: {
    type: 'function',
    path: 'hc_users_export',
    name: 'hc_users_export',
    permission: 'hc_users_export',
    meta: {
      requiresAuth: true
    }
  },
  HC_USERS_DELETE: {
    type: 'function',
    path: 'hc_users_delete',
    name: 'hc_users_delete',
    permission: 'hc_users_delete',
    meta: {
      requiresAuth: true
    }
  },
  HC_USER_DETAILS: {
    path: '/hc-user/:userId',
    name: 'hc_user_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'hc',
      title: 'User Details',
      order: 0,
      main: true
    },
    component: () => import('@hc_views/Users/UserDetails')
  },
  HC_TRIGGERS: {
    path: '/hc-triggers',
    name: 'hc_triggers',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/Triggers/TriggersIndex')
  },
  HC_LOG_SPEND: {
    path: '/hc-log-spend',
    name: 'hc_log_spend',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/LogSpend')
  },
  HC_OFFER_WALL_PERFORMANCE: {
    path: '/hc-offerwall-performance',
    name: 'hc_offer_wall_performance',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'hc',
      title: 'Offerwall Performance',
      order: 6
    },
    component: () => import('@hc_views/OfferWallPerformance')
  },
  HC_SETTINGS: {
    path: '/hc-settings',
    name: 'hc_settings',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/Settings')
  },
  HC_FRONTEND_SETTINGS: {
    path: '/hc-frontend-settings',
    name: 'hc_frontend_settings',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@ps_views/shared/frontend-settings/FrontendSettingsIndex.vue')
  },
  HC_CAMPAIGN_SETTINGS: {
    path: '/hc-campaign-settings',
    name: 'hc_campaign_settings',
    meta: { requiresAuth: true },
    props: { project: 'hey-cash' },
    component: () => import('@ps_views/shared/campaign-settings/CampaignSettingsIndex.vue')
  },
  HC_TUNE_REJECTION_SETTINGS: {
    path: '/hc-tune-rejection-settings',
    name: 'hc_tune_rejection_settings',
    meta: { requiresAuth: true },
    props: { project: 'hey-cash' },
    component: () => import('@ps_views/shared/tune-rejection-settings/TuneRejectionSettingsIndex.vue')
  },
  HC_TUNE_REJECTIONS: {
    path: '/hc-tune-rejections',
    name: 'hc_tune_rejections',
    meta: { requiresAuth: true },
    props: { project: 'hey-cash' },
    component: () => import('@ps_views/shared/tune-rejections/TuneRejectionsIndex.vue')
  },
  HC_BONUS_CODES: {
    path: '/hc-bonus-codes',
    name: 'hc_bonus_codes',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/BonusCodes/BonusCodesIndex.vue')
  },
  HC_BONUS_CODE_REDEMPTIONS: {
    path: '/hc-bonus-code-redemptions',
    name: 'hc_bonus_code_redemptions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'hc',
      title: 'Bonus Codes',
      order: 4
    },
    component: () => import('@hc_views/BonusCodeRedemptions')
  },
  HC_ADJUST_CONFIG: {
    path: '/hc-adjust-config',
    name: 'hc_adjust_config',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@ps_views/shared/adjust-config/AdjustConfigIndex.vue')
  },
  HC_USER_CREDIT: {
    type: 'function',
    path: 'hc_user_credit',
    name: 'hc_user_credit',
    permission: 'hc_user_credit',
    meta: {
      requiresAuth: true
    }
  },
  HC_USER_STREAK_LENGTH: {
    type: 'function',
    path: 'hc_user_streak_length',
    name: 'hc_user_streak_length',
    permission: 'hc_user_streak_length',
    meta: {
      requiresAuth: true
    }
  },
  HC_DYNAMIC_CAMPAIGNS: {
    path: '/hc-dynamic-campaigns',
    name: 'hc_dynamic_campaigns_main',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns')
  },
  HC_DYNAMIC_CAMPAIGNS_EMAILS: {
    path: '/hc-dynamic-campaigns/emails',
    name: 'hc_dynamic_campaigns_emails',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns/Pages/Emails/CampaignsEmails.vue')
  },
  HC_DYNAMIC_CAMPAIGNS_EMAILS_CREATE: {
    path: '/hc-dynamic-campaigns/emails/create',
    name: 'hc_dynamic_campaigns_emails_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  HC_DYNAMIC_CAMPAIGNS_EMAILS_EDIT: {
    path: '/hc-dynamic-campaigns/emails/edit/:id',
    name: 'hc_dynamic_campaigns_emails_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsCreateAndEdit.vue')
  },
  HC_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT: {
    path: '/hc-dynamic-campaigns/emails/:id/translations/edit/:language_code',
    name: 'hc_dynamic_campaigns_emails_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns/Pages/Emails/CampaignsEmailsTranslationsEdit.vue')
  },
  HC_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS: {
    path: '/hc-dynamic-campaigns/push-notifications',
    name: 'hc_dynamic_campaigns_push_notifications',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotifications.vue')
  },
  HC_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE: {
    path: '/hc-dynamic-campaigns/push-notifications/create',
    name: 'hc_dynamic_campaigns_push_notifications_create',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  HC_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT: {
    path: '/hc-dynamic-campaigns/push-notifications/edit/:id',
    name: 'hc_dynamic_campaigns_push_notifications_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsCreateAndEdit.vue')
  },
  HC_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT: {
    path: '/hc-dynamic-campaigns/push-notifications/:id/translations/edit/:language_code',
    name: 'hc_dynamic_campaigns_push_notifications_translations_edit',
    meta: {
      requiresAuth: true
    },
    props: { project: 'hey-cash' },
    component: () => import('@hc_views/DynamicCampaigns/Pages/PushNotifications/CampaignsPushNotificationsTranslationsEdit.vue')
  },
  HC_USER_REWARD_ELIGIBILITY_LOGS: {
    path: '/hc-user-reward-eligibility-logs',
    name: 'hc_user_reward_eligibility_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@hc_views/Users/UserRewardEligibilityLogs')
  },
  HC_USER_LEVEL: {
    type: 'function',
    path: 'hc_user_level',
    name: 'hc_user_level',
    permission: 'hc_user_level',
    meta: {
      requiresAuth: true
    }
  },
  HC_OVERWRITE_ELIGIBLE: {
    type: 'function',
    path: 'hc_overwrite_eligible',
    name: 'hc_overwrite_eligible',
    permission: 'hc_overwrite_eligible',
    meta: {
      requiresAuth: true
    }
  }
}
